import { render, staticRenderFns } from "./DistRole.vue?vue&type=template&id=e9291f74&scoped=true&"
import script from "./DistRole.vue?vue&type=script&lang=js&"
export * from "./DistRole.vue?vue&type=script&lang=js&"
import style0 from "./DistRole.vue?vue&type=style&index=0&id=e9291f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9291f74",
  null
  
)

export default component.exports